// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.image-field-container-BRfW4 {
  display: block;
}

.image-field-label-TphfD {
  font-size: 14px;
  color: var(--color-neutral-800);
  margin-bottom: 8px;
}

.image-field-content-OCuYk {
  width: 100%;
  height: 40px;
  display: flex;
  flex-flow: nowrap;
  align-items: center;
  justify-content: start;
  gap: 10px;
  overflow: hidden;
  cursor: pointer;
  background-color: white;
  transition: border-color 200ms ease;
  border-radius: var(--radius-lg);
  border: 1px solid var(--color-neutral-300);
  padding: 0px 4px 0px 12px;
}

.image-field-content-OCuYk:hover:not(:has(.image-field-clearIcon-jVGaM:hover)) {
  background-color: var(--hover-color);
}

.image-field-content-OCuYk:active:not(:has(.image-field-clearIcon-jVGaM:hover)) {
  background-color: var(--active-color);
}

.image-field-icon-MXfyM {
  --size: 24px;
  flex-shrink: 0;
  color: var(--color-neutral-500);
}

.image-field-image-bOzm6 {
  width: 24px;
  height: 24px;
  display: block;
  flex-shrink: 0;
  object-fit: scale-down;
}

.image-field-name-FE63C {
  flex: 1;
  font-size: 15px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.image-field-placeholder-S2eoW {
  color: var(--color-neutral-500);
}

.image-field-uploadInput-tWgEq {
  display: none;
}

.image-field-clearIcon-jVGaM {
  width: fit-content;
  height: fit-content;
  flex-shrink: 0;
  font-size: 20px;
  color: var(--color-neutral-600);
}
`, "",{"version":3,"sources":["webpack://./src/components/image-field/image-field.module.css"],"names":[],"mappings":"AAAA;EACE,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,+BAA+B;EAC/B,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,sBAAsB;EACtB,SAAS;EACT,gBAAgB;EAChB,eAAe;EACf,uBAAuB;EACvB,mCAAmC;EACnC,+BAA+B;EAC/B,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;EACd,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,OAAO;EACP,eAAe;EACf,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,+BAA+B;AACjC","sourcesContent":[".container {\n  display: block;\n}\n\n.label {\n  font-size: 14px;\n  color: var(--color-neutral-800);\n  margin-bottom: 8px;\n}\n\n.content {\n  width: 100%;\n  height: 40px;\n  display: flex;\n  flex-flow: nowrap;\n  align-items: center;\n  justify-content: start;\n  gap: 10px;\n  overflow: hidden;\n  cursor: pointer;\n  background-color: white;\n  transition: border-color 200ms ease;\n  border-radius: var(--radius-lg);\n  border: 1px solid var(--color-neutral-300);\n  padding: 0px 4px 0px 12px;\n}\n\n.content:hover:not(:has(.clearIcon:hover)) {\n  background-color: var(--hover-color);\n}\n\n.content:active:not(:has(.clearIcon:hover)) {\n  background-color: var(--active-color);\n}\n\n.icon {\n  --size: 24px;\n  flex-shrink: 0;\n  color: var(--color-neutral-500);\n}\n\n.image {\n  width: 24px;\n  height: 24px;\n  display: block;\n  flex-shrink: 0;\n  object-fit: scale-down;\n}\n\n.name {\n  flex: 1;\n  font-size: 15px;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.placeholder {\n  color: var(--color-neutral-500);\n}\n\n.uploadInput {\n  display: none;\n}\n\n.clearIcon {\n  width: fit-content;\n  height: fit-content;\n  flex-shrink: 0;\n  font-size: 20px;\n  color: var(--color-neutral-600);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `image-field-container-BRfW4`,
	"label": `image-field-label-TphfD`,
	"content": `image-field-content-OCuYk`,
	"clearIcon": `image-field-clearIcon-jVGaM`,
	"icon": `image-field-icon-MXfyM`,
	"image": `image-field-image-bOzm6`,
	"name": `image-field-name-FE63C`,
	"placeholder": `image-field-placeholder-S2eoW`,
	"uploadInput": `image-field-uploadInput-tWgEq`
};
export default ___CSS_LOADER_EXPORT___;
